import { handleActions } from 'redux-actions';
import {
  GET_EMPLOYER_DETAILS_SUCCESS,
  GET_ALL_EMPLOYERS_SUCCESS,
  CLEAR_EMPLOYER_DETAILS
} from '../actions/actionTypes';

const initialState = {
  employersList: [],
  pagesQuantity: 0,
  employerDetails: {}
};

export default handleActions(
  {
    [GET_ALL_EMPLOYERS_SUCCESS]: (state, action) => ({
      ...state,
      employersList: action.employersList,
      pagesQuantity: action.pagesQuantity
    }),
    [GET_EMPLOYER_DETAILS_SUCCESS]: (state, action) => ({
      ...state,
      employerDetails: action.payload
    }),
    [CLEAR_EMPLOYER_DETAILS]: (state) => ({
      ...state,
      employerDetails: {}
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/employers.js